// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xeJz","tabsBox":"styles_tabsBox__3ELnX","createButton":"styles_createButton__t7V4o"};